import { render, staticRenderFns } from "./xbzp.vue?vue&type=template&id=3b170f71&scoped=true&"
import script from "./xbzp.vue?vue&type=script&lang=js&"
export * from "./xbzp.vue?vue&type=script&lang=js&"
import style0 from "./xbzp.vue?vue&type=style&index=0&id=3b170f71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b170f71",
  null
  
)

export default component.exports